var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bubble animated fadeInDown",style:(_vm.bubbleStyle),on:{"click":_vm.close}},[_c('span',[_vm._v(_vm._s(_vm.winnersCount))]),_vm._v("个网友已经\n  "),_c('span',[_vm._v("中奖")]),_vm._v("，您也来试试吧\n")])}
var staticRenderFns = []

export { render, staticRenderFns }